module.exports = __webpack_public_path__ + "static/media/img-a.e2b67c1c.jpg";